import React from 'react';
import {View} from 'react-native';

function ContentSectionDivider(props) {
	return <View style={{width: 1, backgroundColor: '#E2E9F4'}} {...props}/>
}

export default ContentSectionDivider;
